<script>
  import Button from '$lib/components/Button.svelte';
  import Modal from '$lib/components/Modal.svelte';
  import { closeModal, showToast } from '$lib/features/app/modals';
  import { logger } from '$lib/logger';
  import { useQueryClient } from '@tanstack/svelte-query';
  import { useDeleteConsultationHistoryMutation } from '../../service';

  let { note } = $props();

  const queryClient = useQueryClient();
  const deleteSavedNoteMutation = useDeleteConsultationHistoryMutation();

  function handleSubmit() {
    $deleteSavedNoteMutation.mutate(
      {
        noteId: note.id,
      },
      {
        onSuccess: () => {
          showToast('Journalen är raderad', 'success');
          queryClient.invalidateQueries({ queryKey: ['notes'] });
          closeModal();
        },
        onError: (e) => {
          showToast(e.message, 'error');
          logger.error('Failed to delete saved note', {
            err: e instanceof Error ? e : undefined,
          });
        },
      },
    );
  }
</script>

<Modal title="Radera den sparade journalanteckningen?" size="sm">
  <form
    onsubmit={(event) => {
      event.preventDefault();
      handleSubmit();
    }}
    class="w-full"
  >
    <div class="mt-4 flex justify-between">
      <Button onclick={closeModal} variant="secondary" iconLeft="cancel">
        Avbryt
      </Button>
      <Button
        type="submit"
        variant="primary"
        class="w-40"
        loading={$deleteSavedNoteMutation.isPending}
      >
        Radera
      </Button>
    </div>
  </form>
</Modal>
